import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./AddUser.css";
import "./employerPortal.css";

const AddUser = () => {
  const [companyId, setCompanyId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [newProfileName, setNewProfileName] = useState("");
  const [newProfileEmail, setNewProfileEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const goBackToCompany = () => {
    const from = location.state?.from;
    if (from) {
      navigate(from);
      return;
    }
    const id = companyId || localStorage.getItem("company_id");
    const isInstitution =
      String(from || "").includes("institution") ||
      location.pathname.includes("institution");
    if (id) {
      navigate(
        isInstitution
          ? `/institution-profile/${id}`
          : `/company-profile/${id}`
      );
      return;
    }
    navigate(isInstitution ? "/institution-details" : "/company-details");
  };

  useEffect(() => {
    const storedCompanyId = localStorage.getItem("company_id");
    if (storedCompanyId) {
      setCompanyId(storedCompanyId);
    } else {
      alert("No company ID found. Please select a company first.");
      goBackToCompany();
    }

    const fetchRoles = async () => {
      try {
        const response = await AxiosInstance.get("companies/roles/");
        if (response.status === 200) {
          setRoleOptions(response.data);
        } else {
          alert("Failed to load roles.");
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
        alert("Error fetching roles.");
      }
    };

    fetchRoles();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    if (!selectedRole) {
      alert("Please select a role.");
      return;
    }

    const newUser = {
      company_id: companyId,
      first_name: firstName,
      last_name: lastName,
      email,
      mobile_no: mobileNo,
      password,
      confirmPassword: "",
    };

    try {
      const userResponse = await AxiosInstance.post(
        `companies/company/users/${companyId}/`,
        newUser
      );

      if (userResponse.status === 201) {
        const userId = userResponse.data.user_id;

        const profileData = {
          user: userId,
          role: selectedRole,
          profiles: profiles.map((p) => ({ profile_name: p.name, email: p.email })),
        };

        const profileResponse = await AxiosInstance.post(
          `companies/user/profile/`,
          profileData
        );

        if (profileResponse.status === 201) {
          alert("User and profiles added successfully!");
          goBackToCompany();
        } else {
          alert("Failed to add profiles.");
        }
      } else {
        alert("Failed to add user.");
      }
    } catch (error) {
      console.error("Error adding user:", error);
      alert("An error occurred while adding the user.");
    }
  };

  const handleAddProfile = () => {
    if (newProfileName.trim() && newProfileEmail.trim()) {
      setProfiles([...profiles, { name: newProfileName.trim(), email: newProfileEmail.trim() }]);
      setNewProfileName("");
      setNewProfileEmail("");
    } else {
      alert("Please fill in both profile name and email.");
    }
  };

  const handleRemoveProfile = (index) => {
    setProfiles(profiles.filter((_, i) => i !== index));
  };

  const closeModal = () => {
    goBackToCompany();
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div
        className="modal d-block als-employer-page"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addUserLabel"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addUserLabel">Add Employee</h5>
            </div>

            {/* Scrollable modal body */}
            <div className="modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>
              <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Mobile No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={mobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                    required
                  />
                </div>
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Role</label>
                  <select
                    className="form-select"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    required
                  >
                    <option value="">Select Role</option>
                    {roleOptions.map((role) => (
                      <option key={role.role_id} value={role.role_id}>
                        {role.role}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Add Profiles</label>
                  <div className="d-flex gap-2 mb-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Profile Name"
                      value={newProfileName}
                      onChange={(e) => setNewProfileName(e.target.value)}
                    />
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Profile Email"
                      value={newProfileEmail}
                      onChange={(e) => setNewProfileEmail(e.target.value)}
                    />
                    <button type="button" className="btn btn-primary" onClick={handleAddProfile}>
                      Add
                    </button>
                  </div>
                </div>

                {profiles.length > 0 && (
                  <div className="mb-3">
                    <label className="form-label">Added Profiles</label>
                    <ul className="list-group">
                      {profiles.map((profile, index) => (
                        <li
                          key={index}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          {profile.name} - {profile.email}
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => handleRemoveProfile(index)}
                          >
                            Remove
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button type="button" className="btn btn-secondary" onClick={closeModal}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </form>
            </div>
            {/* End modal-body */}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
